<form id="parkerFromUntilForm" [formGroup]="fromUntilForm" autocomplete="off">
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label class="control-label required">{{'i18n.shared.from' | translate}}</label>
      <ejs-datetimepicker id="from"
                          formControlName="from"
                          timeFormat="HH:mm"
                          format="dd.MM.yyyy HH:mm"
                          [max]="maxDate">
      </ejs-datetimepicker>
      <app-error-messages [control]="fromUntilForm.controls.from"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label class="control-label">{{'i18n.shared.until' | translate}}</label>
      <ejs-datetimepicker id="until"
                          formControlName="until"
                          timeFormat="HH:mm"
                          format="dd.MM.yyyy HH:mm"
                          [max]="maxDate">
      </ejs-datetimepicker>
      <app-error-messages [control]="fromUntilForm.controls.until"></app-error-messages>
    </div>
  </div>
</form>
